import React, { useEffect } from 'react';
import { usePlansItems } from '@atlassian/jira-plans-item-store';

import Main from './main';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import './styles.module.css';
import TitleBar from './top/title-bar';
import type { PlanPageProps } from './types';

/**
 * $$ UpdateRecentPlans $$
 * This component is used to load the store of the "Plans" menu items from the backend.
 *
 * This component updates the FE store with this new information. If we don't update the FE store, we will see
 * previous list of recent plans for a moment and then it updates to new list once /navigation endpoint
 * returns the results.
 */
const UpdateRecentPlans = () => {
	const [, { load }] = usePlansItems();

	useEffect(() => {
		load();
	}, [load]);

	return null;
};

export default function PlanPage(props: PlanPageProps) {
	// eslint-disable-next-line @typescript-eslint/no-shadow
	const { TitleBar, Main } = props;
	return (
		<>
			<TitleBar />
			<Main />
			<UpdateRecentPlans />
		</>
	);
}

PlanPage.defaultProps = {
	TitleBar,
	Main,
};
